/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchRgiRiskCommandDto
 */
export interface PatchRgiRiskCommandDto {
    /**
     * 
     * @type {Date}
     * @memberof PatchRgiRiskCommandDto
     */
    contractStartDate: Date;
}

/**
 * Check if a given object implements the PatchRgiRiskCommandDto interface.
 */
export function instanceOfPatchRgiRiskCommandDto(value: object): value is PatchRgiRiskCommandDto {
    if (!('contractStartDate' in value) || value['contractStartDate'] === undefined) return false;
    return true;
}

export function PatchRgiRiskCommandDtoFromJSON(json: any): PatchRgiRiskCommandDto {
    return PatchRgiRiskCommandDtoFromJSONTyped(json, false);
}

export function PatchRgiRiskCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchRgiRiskCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contractStartDate': (new Date(json['contractStartDate'])),
    };
}

export function PatchRgiRiskCommandDtoToJSON(json: any): PatchRgiRiskCommandDto {
    return PatchRgiRiskCommandDtoToJSONTyped(json, false);
}

export function PatchRgiRiskCommandDtoToJSONTyped(value?: PatchRgiRiskCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractStartDate': ((value['contractStartDate']).toISOString().substring(0,10)),
    };
}

